export default __webpack_public_path__ + "static/media/background.d206ff3b.jpg";